import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dynamicLinkFormElementComponent from './dynamicLinkFormElement.component';

let dynamicLinkFormElementModule = angular.module('dynamicLinkFormElement', [
  uiRouter
])

  .component('dynamicLinkFormElement', dynamicLinkFormElementComponent)

  .name;

export default dynamicLinkFormElementModule;
